module.exports = __webpack_public_path__ + "img/multiplayer_pressed.942963d8.png";